//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser, UsesKintellGroup, UsesKintellGroupPermission } from '@/mixins'
import TheNavigationDrawer from './TheNavigationDrawer'

export default {
  components: { TheNavigationDrawer },

  mixins: [
    UsesAuthenticatedUser,
    UsesKintellGroup,
    UsesKintellGroupPermission
  ],

  data () {
    return {
      pages: {
        articles: '/articles',
        becomeAdvisor: '/my-kintell/kintell-cards/create',
        bookings: '/my-kintell/bookings',
        calendar: '/my-kintell/my-calendar',
        credits: '/my-kintell/more/credits',
        dashboard: '/my-kintell/dashboard',
        faqs: '/faq',
        favourites: '/my-kintell/more/favourites',
        featureVideo: '/features/video-meetings',
        featureCalendar: '/features/calendar-and-bookings',
        featureCards: '/features/kintell-cards',
        featurePay: '/features/payment-integration',
        forBusiness: '/for-business',
        getInTouch: '/get-in-touch',
        joinNow: '/join-now',
        login: '/sign-in',
        myKintellCards: '/my-kintell/kintell-cards',
        myRewards: '/my-kintell/more',
        personalDetails: '/my-kintell/my-details',
        pricing: '/pricing',
        marketplace: '/search',
        signOut: '/sign-out',
      }
    }
  },
  computed: {
    nameTitle () {
      if (!this.authenticatedUser || !this.authenticatedUser.firstName) {
        return ''
      }

      if (this.authenticatedUser.fullName.length <= 15) {
        return this.authenticatedUser.fullName
      }

      return this.authenticatedUser.firstName.length > 15 ? 'My Kintell' : this.authenticatedUser.firstName
    },

    alertCount () {
      return this.authenticatedUser?.stats?.alerts + (this.authenticatedUser?.stats?.bookingActive ? 1 : 0)
    },

    classes () {
      return {
        'k-header--dark': this.showDarkHeader,
      }
    },

    isOnArticles () {
      return this.$route.path.includes('/articles')
    },

    ctaGetStarted () {
      return this.$route.path === '/for-business'
        ? { path: this.pages.getInTouch, text: `Get in touch for a demo` }
        : { path: `${this.pages.joinNow}?redirectTo=my-kintell-dashboard`, text: `Get started now - for free!` }
    },

    showDarkHeader () {
      return this.isOnArticles
    },

    hideSearchField () {
      const routeName = this.$route.name
      // match search page or any group page
      return routeName?.match(/(search|g -.+)/) || !this.notOnGroupWhiteLabelPage
    },

    notOnGroupWhiteLabelPage () {
      return !this.onGroupKintellPage && !this.isOnGroupCard
    },

    activeLogo () {
      const kintellGroup = this.activeKintellGroup
      if (kintellGroup && kintellGroup?.logoUrl) {
        let link = `/g/${kintellGroup.slug}`

        // if the group is closed we don't want them to click the logo
        if (!this.canPerform(this.permissions.CLICK_LOGO, kintellGroup)) {
          link = '#'
        }

        return {
          url: kintellGroup.logoUrl,
          link,
        }
      } else {
        return {
          link: '/'
        }
      }
    },

    userBadgeLabel () {
      let userBadge = ''

      if (this.authenticatedUser.isKintellPlus) {
        userBadge = 'PLUS'
      } else if (this.authenticatedUser.isKintellPro) {
        userBadge = 'PRO'
      }

      return userBadge
    },

    isOnGroupCard () {
      const activeKintellCard = this.$store.getters['kintellCards/activeKintellCard']

      return !!activeKintellCard?.kintellGroupId
    }
  },
}
